<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import {CountTo} from "vue3-count-to";
import {getMemberLevelLogStatistics, listMemberLevelLog} from "@/api/memberLevelLog/memberLevelLog.js";
import {listTenant} from "@/api/user/user.js";
/*初次加载*/
onMounted(async () => {
  await handleGetTenant('init')
  await handleSearch()
})

// 会员统计数据
const statisticsData = ref({
  regularMemberCount: 0,
  vipMemberCount: 0,
  svipMemberCount: 0,
  premierMemberCount: 0
})
// 获取会员统计数据
const handleGetStatistics = async (param) => {
  try {
    statisticsData.value = await getMemberLevelLogStatistics(param)
  } catch (e) {
    console.log(e)
  }
}

/*搜索功能*/
// 表单数据
const formData = reactive({
  tenantId: null,
  date: null,
  endDate: null,
  memberLevelType: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    const param = {
      // 只查询租户推荐
      referrerType: "TENANT",
      referrerId: formData.tenantId,
      startTime: formData.date ? {
        year: moment(formData.date).startOf('month').format('YYYY'),
        month: moment(formData.date).startOf('month').format('MM')
      } : null,
      endTime: formData.endDate ? {
        year: moment(formData.endDate).startOf('month').format('YYYY'),
        month: moment(formData.endDate).startOf('month').format('MM')
      } : null,
      memberLevelType: formData.memberLevelType,
    }
    console.log("param", param)
    loading.value = true
    const res = await listMemberLevelLog(page, param)
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    await handleGetStatistics(param)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.tenantId = null
  formData.date = null
  formData.endDate = null
  cacheTenant.value = {
    name: null,
    tenantId: null
  }
  formData.memberLevelType = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '商家名称', key: 'tenantName', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '手机号', key: 'phone', nowrap: true },
  { title: '等级', key: 'memberLevel', nowrap: true },
  { title: '时间', key: 'crTime', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 商家列表
const tenantListArr = ref([])
// 商家总数条
const memberTotal = ref(0)
// 商家翻页锚点
const YTTablePaginationMemberRef = ref()
// 处理商家翻页
const handleChangeMemberPage = () => {
  handleGetTenant()
}
// 商家列表加载状态
const tenantLoading = ref(false)
// 商家下拉搜索值
const tenantSelectKey = ref()
// 处理搜索条件列表：商家
const handleGetTenant = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationMemberRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationMemberRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationMemberRef.value.getPageSize()
      }
      tenantLoading.value = true
      const res = await listTenant(param, {keyword: tenantSelectKey.value})
      tenantListArr.value = res.list
      memberTotal.value = parseInt(res.total)
      tenantLoading.value = false
    } catch (e) {
      console.log(e)
      tenantLoading.value = false
    }
  })
}
// 缓存选择的商家
const cacheTenant = ref({
  name: null,
  tenantId: null
})
// 处理选择器选择商家
const handleSelectTenant = (e) => {
  formData.tenantId = e
  cacheTenant.value = tenantListArr.value.find(i => i.tenantId === e)
  console.log("formData", formData)
}

// 处理选择器开始日期选择
const handleSelectDate = (date) => {
  console.log("date", date)
  formData.date = handleDateFormat(date)
  // 校验结束日期是否小于开始日期
  if (moment(formData.date).isAfter(moment(formData.endDate))) {
    formData.endDate = null
  }
}
// 处理选择器结束日期选择
const handleSelectEndDate = (date) => {
  console.log("endDate", date)
  formData.endDate = handleDateFormat(date)
  console.log("form.endDate", formData.endDate)
}
// 处理日期格式
const handleDateFormat = (date) => {
  return moment(date).format('YYYY-MM-DD')
}
// 处理选择用户等级
const handleSelectMemberLevel = (type) => {
  formData.memberLevelType = type
  handleSearch('btnSearch')
}

// 处理点击商家下拉列表
const handleClickSelect = (e) => {
  // 下拉展示菜单时重新请求商家列表
  if (e) {
    handleGetTenant('search')
  }
}

</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-select
                        ref="tenantListRef"
                        v-model="cacheTenant.name"
                        :items="tenantListArr"
                        item-title="name"
                        item-value="tenantId"
                        label="商家"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        @update:modelValue="handleSelectTenant"
                        :loading="tenantLoading"
                        placeholder="请选择商家"
                        :menu-props="{maxHeight: '550px'}"
                        @update:menu="handleClickSelect"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="tenantSelectKey"
                              placeholder="请输入商家名称"
                              label="商家名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetTenant('search')"
                              @keydown.enter="handleGetTenant('search')"
                              :disabled="tenantLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2" v-if="memberTotal > 0"></v-divider>
                        <YTTablePagination v-if="memberTotal > 0" ref="YTTablePaginationMemberRef" :pageSize="5" :total="memberTotal" @page-change="handleChangeMemberPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.date"
                        :model-value="formData.date ? handleDateFormat(formData.date) : null"
                        label="开始日期"
                        variant="outlined"
                        placeholder="请选择开始日期"
                        :menu-props="{maxHeight: '550px'}"
                    >
                      <template v-slot:no-data style="max-height: 550px">
                        <div class="flex_center" style="position: relative">
                          <v-date-picker color="#ED5513" title="选择开始日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectDate" v-model="formData.date" show-adjacent-months>
                            <template #header>
                              <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.date ? handleDateFormat(formData.date) : "请选择开始日期" }}</div>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.endDate"
                        :model-value="formData.endDate  ? handleDateFormat(formData.endDate) : null"
                        label="结束日期"
                        variant="outlined"
                        placeholder="请选择结束日期"
                        :menu-props="{maxHeight: '550px'}"
                    >
                      <template v-slot:no-data style="max-height: 550px">
                        <div class="flex_center" style="position: relative">
                          <v-date-picker :min="formData.date" color="#ED5513" title="选择结束日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectEndDate" v-model="formData.endDate" show-adjacent-months>
                            <template #header>
                              <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.endDate ? handleDateFormat(formData.endDate) : "请选择结束日期" }}</div>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('any', 'memberLevelLog:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('any', 'memberLevelLog:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div class="flex_left mg_b_4">
              <div class="dataBox mg_r_2 cursor-pointer" style="position: relative" @click="handleSelectMemberLevel('REGULAR')">
                <countTo
                    :title="0"
                    class="dataBox_title txt_overflow"
                    :startVal="0"
                    :endVal="parseInt(statisticsData?.regularMemberCount)"
                    :duration="3000"
                ></countTo>
                <div class="dataBox_SubTitle">普通会员</div>
                <div class="btn_check" v-if="formData.memberLevelType === 'REGULAR'">
                  <v-icon color="#fff" size="x-small" icon="mdi-check"></v-icon>
                </div>
              </div>
              <div class="dataBox mg_r_2 cursor-pointer" style="position: relative" @click="handleSelectMemberLevel('VIP')">
                <countTo
                    :title="0"
                    class="dataBox_title txt_overflow"
                    :startVal="0"
                    :endVal="parseInt(statisticsData?.vipMemberCount)"
                    :duration="3000"
                ></countTo>
                <div class="dataBox_SubTitle">VIP会员</div>
                <div class="btn_check" v-if="formData.memberLevelType === 'VIP'">
                  <v-icon color="#fff" size="x-small" icon="mdi-check"></v-icon>
                </div>
              </div>
              <div class="dataBox mg_r_2 cursor-pointer" style="position: relative" @click="handleSelectMemberLevel('SVIP')">
                <countTo
                    :title="0"
                    class="dataBox_title txt_overflow"
                    :startVal="0"
                    :endVal="parseInt(statisticsData?.svipMemberCount)"
                    :duration="3000"
                ></countTo>
                <div class="dataBox_SubTitle">SVIP会员</div>
                <div class="btn_check" v-if="formData.memberLevelType === 'SVIP'">
                  <v-icon color="#fff" size="x-small" icon="mdi-check"></v-icon>
                </div>
              </div>
              <div class="dataBox mg_r_2 cursor-pointer" style="position: relative" @click="handleSelectMemberLevel('PREMIER')">
                <countTo
                    :title="0"
                    class="dataBox_title txt_overflow"
                    :startVal="0"
                    :endVal="parseInt(statisticsData?.premierMemberCount)"
                    :duration="3000"
                ></countTo>
                <div class="dataBox_SubTitle">Premier会员</div>
                <div class="btn_check" v-if="formData.memberLevelType === 'PREMIER'">
                  <v-icon color="#fff" size="x-small" icon="mdi-check"></v-icon>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:item.nickname=" { item } ">
            {{item.nickname ? item.nickname : "-"}}
          </template>

          <template v-slot:item.memberLevel=" { item }">
            <div>{{item.levelName}}</div>
          </template>

          <template v-slot:item.crUserName=" { item } ">
            {{item.type === 'SYSTEM' ? 'System' : item.crUserName}}
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
